import axios from "axios";
import { useEffect, useState } from "react";
import Apiurl from "../../environment/Apiurl"; // Ensure this points to your API base URL
import { useNavigate } from "react-router-dom";

function AddPurchaseOrder() {
  // State declarations
  const [responseSupplierData, setResponseSupplierData] = useState([]);
  const [responseMedicineMasterData, setResponseMedicineMasterData] = useState(
    []
  );
  const [supplierSearch, setSupplierSearch] = useState("");
  const [filteredSuppliers, setFilteredSuppliers] = useState([]);
  const [showSupplierDropdown, setShowSupplierDropdown] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [medicineSearch, setMedicineSearch] = useState("");
  const [filteredMedicines, setFilteredMedicines] = useState([]);
  const [showMedicineDropdown, setShowMedicineDropdown] = useState(false);
  const [selectedMedicine, setSelectedMedicine] = useState(null);
  const [purchaseOrderNo, setPurchaseOrderNo] = useState("");
  const [quantity, setQuantity] = useState("");
  const [packageType, setPackageType] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [tableRows, setTableRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  // Fetch generated purchase order number
  const fetchGenerate = async () => {
    try {
      const response = await axios.get(`${Apiurl}/generate_purchase_order_no`);
      const purchaseOrderId = response.data.purchase_order_no;
      console.log("Generated purchase order ID:", purchaseOrderId);
      setPurchaseOrderNo(purchaseOrderId);
    } catch (error) {
      console.error(
        "Error fetching generated purchase order ID:",
        error.message
      );
      setErrors((prev) => ({
        ...prev,
        fetch: "Failed to generate purchase order ID. Please try again.",
      }));
    }
  };

  // Fetch supplier data
  const fetchSupplierData = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${Apiurl}/supplier_pharmacy`);
      setResponseSupplierData(response.data || []);
      setFilteredSuppliers(response.data || []);
    } catch (error) {
      setErrors((prev) => ({
        ...prev,
        fetch: `Failed to fetch suppliers: ${error.message}`,
      }));
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch medicine master data
  const fetchMedicineMasterData = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${Apiurl}/medicine_master`);
      setResponseMedicineMasterData(response.data || []);
      setFilteredMedicines(response.data || []);
    } catch (error) {
      setErrors((prev) => ({
        ...prev,
        fetch: `Failed to fetch medicines: ${error.message}`,
      }));
    } finally {
      setIsLoading(false);
    }
  };


    useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  
  // Handle supplier search
  const handleSupplierSearch = (searchValue) => {
    setSupplierSearch(searchValue);
    setShowSupplierDropdown(true);
    if (!searchValue.trim()) {
      setFilteredSuppliers(responseSupplierData);
      return;
    }
    const filtered = responseSupplierData.filter((supplier) =>
      [supplier.supplier_name, supplier.supplier_id, supplier.mobile].some(
        (field) =>
          field?.toString().toLowerCase().includes(searchValue.toLowerCase())
      )
    );
    setFilteredSuppliers(filtered);
  };

  // Handle supplier selection
  const handleSupplierSelect = (supplier) => {
    setSelectedSupplier(supplier);
    setSupplierSearch(
      `${supplier.supplier_id} - ${supplier.supplier_name} - ${supplier.mobile}`
    );
    setShowSupplierDropdown(false);
    setErrors((prev) => ({ ...prev, supplier: "" }));
  };

  // Handle medicine search
  const handleMedicineSearch = (searchValue) => {
    setMedicineSearch(searchValue);
    setShowMedicineDropdown(true);
    if (!searchValue.trim()) {
      setFilteredMedicines(responseMedicineMasterData);
      return;
    }
    const filtered = responseMedicineMasterData.filter((medicine) =>
      medicine.medicine_name?.toLowerCase().includes(searchValue.toLowerCase())
    );
    setFilteredMedicines(filtered);
  };

  // Handle medicine selection
  const handleMedicineSelect = (medicine) => {
    setSelectedMedicine(medicine);
    setMedicineSearch(medicine.medicine_name);
    setShowMedicineDropdown(false);
    setErrors((prev) => ({ ...prev, medicine: "" }));
  };

  // Add medicine to table
  const handleAddMedicine = () => {
    const newErrors = {};
    if (!selectedMedicine) newErrors.medicine = "Medicine is required";
    if (!quantity || isNaN(quantity) || quantity <= 0)
      newErrors.quantity = "Valid quantity is required";
    if (!packageType) newErrors.package = "Package is required";
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    const newRow = {
      id: tableRows.length + 1,
      medicine_id: selectedMedicine._id,
      medicine_name: selectedMedicine.medicine_name,
      hsn_code: selectedMedicine.hsn_code,
      package: packageType,
      quantity,
      expiry_date: expiryDate,
    };

    setTableRows([...tableRows, newRow]);
    setSelectedMedicine(null);
    setMedicineSearch("");
    setQuantity("");
    setPackageType("");
    setExpiryDate("");
    setErrors((prev) => ({
      ...prev,
      medicine: "",
      quantity: "",
      package: "",
      expiryDate: "",
    }));
  };

  // Handle form submission
  const handleSubmit = async () => {
    const newErrors = {};
    if (!purchaseOrderNo)
      newErrors.purchaseOrderNo = "Purchase Order No is required";
    if (tableRows.length === 0)
      newErrors.table = "At least one medicine is required";
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    setIsLoading(true);
    try {
      // Prepare items for the purchase order
      const items = tableRows.map((row) => ({
        medicine_id: row.medicine_id,
        hsn_code: row.hsn_code,
        package: row.package,
        quantity: row.quantity,
      }));

      // Create the purchase order
      const orderResponse = await axios.post(`${Apiurl}/purchase_order`, {
        purchase_order_no: purchaseOrderNo,
        date: document.querySelector('input[name="date"]').value,
        supplier_id: selectedSupplier ? selectedSupplier.supplier_id : "",
        supplier_gstin: selectedSupplier ? selectedSupplier.gstin_no : "",
        order_status: "Pending",
        created_by: "user_id_here", // Replace with actual user ID or logic
        items,
      });

      console.log("Purchase order response:", orderResponse);
      alert("Purchase order created successfully!");
      setPurchaseOrderNo("");
      setSelectedSupplier(null);
      setSupplierSearch("");
      setTableRows([]);
      navigate("/pharmacy/purchase-order");
    } catch (error) {
      console.error("Error creating purchase order:", error);
      setErrors((prev) => ({
        ...prev,
        submit: `Error creating purchase order: ${error.message}`,
      }));
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch initial data on component mount
  useEffect(() => {
    fetchGenerate();
    fetchSupplierData();
    fetchMedicineMasterData();
  }, []);

  return (
    <div className="p-3">
      {/* Purchase Order Form */}
      <div className="card card-body mb-2">
        <div className="row mb-2">
          <div className="col-lg-3">
            <label className="form-label fw-bold">Purchase Order No</label>
            <div className="position-relative">
              <input
                type="text"
                className={`form-control ${errors.purchaseOrderNo ? "is-invalid" : ""
                  }`}
                value={purchaseOrderNo}
                onChange={(e) => setPurchaseOrderNo(e.target.value)}
              />
              {errors.purchaseOrderNo && (
                <div className="invalid-feedback">{errors.purchaseOrderNo}</div>
              )}
            </div>
          </div>

          <div className="col-lg-3">
            <label className="form-label fw-bold">Date</label>
            <input
              type="date"
              className="form-control"
              name="date"
              defaultValue={new Date().toISOString().split("T")[0]}
            />
          </div>

          <div className="col-lg-3">
            <label className="form-label fw-bold">Supplier</label>
            <div className="position-relative">
              <input
                type="text"
                className={`form-control ${errors.supplier ? "is-invalid" : ""
                  }`}
                placeholder="Search by name, ID, or mobile..."
                value={supplierSearch}
                onChange={(e) => handleSupplierSearch(e.target.value)}
                onFocus={() => setShowSupplierDropdown(true)}
              />
              {errors.supplier && (
                <div className="invalid-feedback">{errors.supplier}</div>
              )}
              {showSupplierDropdown && (
                <div
                  className="position-absolute w-100 bg-white border rounded shadow-lg"
                  style={{
                    top: "100%",
                    zIndex: 1050,
                    maxHeight: "200px",
                    overflowY: "auto",
                  }}
                >
                  {filteredSuppliers.length > 0 ? (
                    filteredSuppliers.map((supplier, index) => (
                      <div
                        key={index}
                        className="p-2 hover-bg-light cursor-pointer border-bottom"
                        onClick={() => handleSupplierSelect(supplier)}
                        onMouseEnter={(e) =>
                          (e.target.style.backgroundColor = "#f8f9fa")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.backgroundColor = "transparent")
                        }
                      >
                        <div className="fw-bold">{supplier.supplier_name}</div>
                        <div className="text-muted small">
                          ID: {supplier.supplier_id} | Mobile: {supplier.mobile}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="p-2 text-muted text-center">
                      No suppliers found
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="col-lg-3">
            <label className="form-label fw-bold">Supplier GSTIN</label>
            <input
              type="text"
              className="form-control"
              value={selectedSupplier?.gstin_no || ""}
              disabled
            />
          </div>
        </div>
      </div>

      {/* Medicine Selection Form */}
      <div className="border rounded p-3 bg-white">
        <div className="row mb-2">
          <div className="col-lg-4">
            <label className="form-label fw-bold">Medicine Name</label>
            <div className="position-relative">
              <input
                type="text"
                className={`form-control ${errors.medicine ? "is-invalid" : ""
                  }`}
                placeholder="Search medicine..."
                value={medicineSearch}
                onChange={(e) => handleMedicineSearch(e.target.value)}
                onFocus={() => setShowMedicineDropdown(true)}
              />
              {errors.medicine && (
                <div className="invalid-feedback">{errors.medicine}</div>
              )}
              {showMedicineDropdown && (
                <div
                  className="position-absolute w-100 bg-white border rounded shadow-lg"
                  style={{
                    top: "100%",
                    zIndex: 1050,
                    maxHeight: "200px",
                    overflowY: "auto",
                  }}
                >
                  {filteredMedicines.length > 0 ? (
                    filteredMedicines.map((medicine, index) => (
                      <div
                        key={index}
                        className="p-2 hover-bg-light cursor-pointer border-bottom"
                        onClick={() => handleMedicineSelect(medicine)}
                        onMouseEnter={(e) =>
                          (e.target.style.backgroundColor = "#f8f9fa")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.backgroundColor = "transparent")
                        }
                      >
                        <div className="fw-bold">{medicine.medicine_name}</div>
                        <div className="text-muted small">
                          HSN: {medicine.hsn_code}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="p-2 text-muted text-center">
                      No medicines found
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="col-lg-2">
            <label className="form-label fw-bold">HSN Code</label>
            <input
              type="text"
              className="form-control"
              value={selectedMedicine?.hsn_code || ""}
              readOnly
            />
          </div>

          <div className="col-lg-2">
            <label className="form-label fw-bold">Package</label>
            <select
              className={`form-control ${errors.package ? "is-invalid" : ""}`}
              value={packageType}
              onChange={(e) => setPackageType(e.target.value)}
            >
              <option value="">Select Package</option>
              <option value="Strip">Strip</option>
              <option value="Bottle">Bottle</option>
              <option value="Vial">Vial</option>
              <option value="Box">Box</option>
            </select>
            {errors.package && (
              <div className="invalid-feedback">{errors.package}</div>
            )}
          </div>

          <div className="col-lg-2">
            <label className="form-label fw-bold">Quantity</label>
            <input
              type="text"
              className={`form-control ${errors.quantity ? "is-invalid" : ""}`}
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
            />
            {errors.quantity && (
              <div className="invalid-feedback">{errors.quantity}</div>
            )}
          </div>

          <div className="col-lg-2 mt-4">
            <button
              type="button"
              className="btn btn-sm btn-success"
              onClick={handleAddMedicine}
            >
              ADD
            </button>
          </div>
        </div>

        {/* Table for Added Medicines */}
        <div className="table-responsive table-scroll-350">
          <table className="table table-bordered mb-0">
            <thead className="text-center">
              <tr>
                {[
                  "S.no",
                  "Medicine Name",
                  "HSN Code",
                  "Qty",
                  "Package",
                  "Action",
                ].map((h, idx) => (
                  <th
                    key={idx}
                    style={{ backgroundColor: "#01AEBE", color: "white" }}
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="text-center">
              {tableRows.map((row, index) => (
                <tr key={row.id}>
                  <td>{index + 1}</td>
                  <td>{row.medicine_name}</td>
                  <td>{row.hsn_code}</td>
                  <td>{row.quantity}</td>
                  <td>{row.package}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() =>
                        setTableRows(tableRows.filter((r) => r.id !== row.id))
                      }
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {tableRows.length === 0 && (
            <div className="text-center text-muted mt-2">No items added</div>
          )}
          {errors.table && (
            <div className="text-center text-danger mt-2">{errors.table}</div>
          )}
        </div>
      </div>

      {/* Submit Button */}
      <div className="mt-3 text-center">
        <button
          className="btn btn-primary"
          onClick={handleSubmit}
          disabled={isLoading}
        >
          {isLoading ? "Submitting..." : "Submit Purchase Order"}
        </button>
      </div>

      {/* Overlay to close dropdowns */}
      {(showSupplierDropdown || showMedicineDropdown) && (
        <div
          className="position-fixed w-100 h-100"
          style={{ top: 0, left: 0, zIndex: 1040, background: "transparent" }}
          onClick={() => {
            setShowSupplierDropdown(false);
            setShowMedicineDropdown(false);
          }}
        />
      )}
    </div>
  );
}

export default AddPurchaseOrder;

